import { render, staticRenderFns } from "./servicerLogin.vue?vue&type=template&id=4c465089&scoped=true&"
import script from "./servicerLogin.vue?vue&type=script&lang=js&"
export * from "./servicerLogin.vue?vue&type=script&lang=js&"
import style0 from "./servicerLogin.vue?vue&type=style&index=0&id=4c465089&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c465089",
  null
  
)

export default component.exports